import $ from 'jquery';

import 'jquery-circle-progress';

let message1;
let message2;
let go1 = false;
let go2 = false;
let go3 = false;
const speedTest = () => {
  const image = `${window.location.protocol}//${window.location.host}/wp-content/plugins/speed-manager/images/`;
  const image1 = `${image}gz.png`;
  const image2 = `${image}other.png`;
  const image3 = `${image}load.png`;
  let circle;
  let circle2;
  let width;
  let width2;

  function makeCircle() {
    $('#circle_group').removeClass('invisible');
    circle = $('#info1');
    circle2 = $('#info2');
    width = circle.width();
    width2 = circle2.width();
    if (width < 350) { width = '350px'; }
    if (width2 < 350) { width2 = '350px'; }
    $('#circle1').css(
      {
        width,
        height: width,
      },
    );
    $('#circle2').css(
      {
        width,
        height: width2,
      },
    );
    width = $('#circle1').width();
    width2 = $('#circle2').width();
  }
  function applyCss() {
    const theParent = $('#speed');
    width = $('#circle1').width();
    width2 = $('#circle2').width();
    theParent.css(
      {
        'align-content': 'center',
        'align-items': 'center',
        'text-align': 'center',
      },
    );
    theParent.find('#go').css(
      {
        'margin-left': 'auto',
        'margin-right': 'auto',
        'margin-top': '5px',
        width: '260px',
        color: '#000',
      },
    );
    theParent.find('#all_in_gbzone').css(
      {
        'margin-bottom': '10px',
        'text-align': 'center',
      },
    );
    theParent.find('#info1').css(
      {
        'text-align': 'center',
      },
    );
    theParent.find('#text1').css(
      {
        'font-weight': '900',
        color: 'red',
        'font-size': '16px',
        'text-align': 'center',
      },
    );
    theParent.find('#text2').css(
      {
        'font-weight': '900',
        color: 'red',
        'font-size': '16px',
        'text-align': 'center',
      },
    );
    theParent.find('#text2').css(
      {
        'text-align': 'center',
      },
    );
    theParent.find('#canvas1Text').css(
      {
        'text-align': 'center',
        display: 'inline-block',
        'max-width': '220px',
        'min-width': '220px',
        width: '220px',
        'z-index': '3',
      },
    );
    theParent.find('#canvas2Text').css(
      {
        'text-align': 'center',
        display: 'inline-block',
        'max-width': '220px',
        'min-width': '220px',
        width: '220px',
        'z-index': '3',
      },
    );
    theParent.find('.selection label').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.selection input').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.selection select').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.theCanvas').css(
      {
        display: 'block',
        padding: '0',
        // 'padding': '20px',
        'background-color': 'rgba(0,0,0,0)',
        '-moz-border-radius': '0',
        '-webkit-border-radius': '0',
        '-khtml-border-radius': '0',
        'border-radius': '0',
        // 'border':'5px solid black',
        // 'border-top':'5px solid black',
        // 'border-left':'5px solid black',
        // 'border-right':'5px solid black',
        'text-align': 'center',
        'align-content': 'center',
        height: width,
        width,
      },
    );
    theParent.find('canvas').css(
      {
        display: 'block',
        'text-align': 'center',
        'margin-left': 'auto',
        'margin-right': 'auto',
        // Small leftward nudge so the radial drawing aligns visually
        // with the gauge segments (the PNG content sits very slightly
        // left of the .theCanvas geometric center). No vertical offset
        // — shifting the canvas down made the orange tail descend past
        // the gauge image, which the user flagged as "the left one
        // drops".
        position: 'relative',
        left: '-10px',
      },
    );
    // console.log(image);
    theParent.find('#circle1').css(
      {
        'background-image': `url(${image1})`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        height: width,
        width,
      },
    );
    // console.log(image);
    theParent.find('#circle2').css(
      {
        'background-image': `url(${image2})`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        height: width2,
        width,
      },
    );
    // Fixed-size text box above the gauge. width matches the gauge
    // image, and a min-height tall enough for the longest rotating
    // message ("Wow I wouldn't watch a video with that connection!.")
    // keeps the row from reflowing taller when shorter messages cycle
    // in — without this the gauge below visibly bounces every tick.
    // Fixed-size text box above each gauge: width matches the gauge
    // image and the height is LOCKED (height + min-height + max-height
    // all set to 63px) so a longer rotating message can never reflow
    // the row taller, which used to make the gauge below visibly bounce.
    // overflow: hidden hard-caps any overflow if a future message is
    // too long to fit two lines at 14px.
    theParent.find('#info1 strong, #info2 strong').css(
      {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'text-align': 'center',
        width: '350px',
        'max-width': '100%',
        height: '63px',
        'min-height': '63px',
        'max-height': '63px',
        overflow: 'hidden',
        'font-weight': '900',
        'font-size': '14px',
        'line-height': '1.3',
      },
    );
  }
  $(window).resize(() => {
    applyCss();
    // $("#circle_group").addClass("invisible");
    // if(go2 || go3) {
    makeCircle();
    // }
    if (go1) {
      $('#go').trigger('click');
    }
  });
  $('#go').click(() => {
    applyCss();
    makeCircle();
    applyCss();
    makeCircle();
    go1 = true;
    go2 = true;
    go3 = true;
    // console.log(width);
    const pb_speed = parseFloat($('#pb_selection').val());
    const others_speed = parseFloat($('#others_selection').val());
    const bytes_total = parseFloat($('#size_selection').val());
    // console.log(pb_speed, others_speed, bytes_total);
    const pb_sp = ((bytes_total * 1.024) / (pb_speed)) * 8; // 8 is because 1mb dowload at 1mbit per second takes 8 secs same as 1gb download at 1gbit /sec speed takes 8 seconds
    const ot_sp = ((bytes_total * 1.024) / (others_speed)) * 8;
    const min_pb = Math.floor(pb_sp / 60);
    const sec_pb = pb_sp - (min_pb * 60);
    const hour_ot = Math.floor(ot_sp / 3600);
    const min_ot = Math.floor((ot_sp - (hour_ot * 3600)) / 60);
    const sec_ot = ot_sp - (hour_ot * 3600) - (min_ot * 60);
    message1 = 'With the GigaZone this download will take approximately<br>';
    message2 = 'With the selected connection this download will take approximately<br>';
    if (min_pb > 0) {
      message1 += min_pb;
      if (min_pb !== 1) {
        message1 += ' minutes ';
      } else {
        message1 += ' minute ';
      }
    }

    if (sec_pb > 0) {
      if ((sec_pb % 1) === 0) {
        message1 += sec_pb;
      } else {
        message1 += sec_pb.toFixed(2);
      }
      if (sec_pb !== 1) {
        message1 += ' seconds';
      } else {
        message1 += ' second';
      }
    }
    if (hour_ot > 0) {
      message2 += hour_ot;
      if (hour_ot !== 1) {
        message2 += ' hours ';
      } else {
        message2 += ' hour ';
      }
    }
    if (min_ot > 0) {
      message2 += min_ot;
      if (min_ot !== 1) {
        message2 += ' minutes ';
      } else {
        message2 += ' minute ';
      }
    }
    if (sec_ot > 0) {
      if ((sec_ot % 1) === 0) {
        message2 += sec_ot;
      } else {
        message2 += sec_ot.toFixed(2);
      }
      if (sec_ot !== 1) {
        message2 += ' seconds';
      } else {
        message2 += ' second';
      }
    }
    const difference = pb_speed / others_speed;
    const in_progress = 'In progress.';
    let done_gz = 'Done! now waiting for them.';
    const done_gz1 = "Wow I wouldn't watch a video with that connection!.";
    const done_gz2 = 'No worries, they will be done some day.';
    const done_gz3 = 'zzz... zzz... hmmmm.';
    const done_gz4 = 'ok now, wait... wait... argh.';
    const done_gz5 = 'Are they done yet?.';
    $('#span_differences').removeClass('invisible');
    if (difference % 1 === 0) {
      $('#difference').html(difference);
    } else {
      $('#difference').html(Math.round(difference * 100) / 100);
    }
    const duration_by = 1000;
    const strong1 = $('#circle1').parent('div').find('strong');
    const strong2 = $('#circle2').parent('div').find('strong');

    let d_dots_counter = 0;
    let count_expressions = 0;
    let d_dots = '';
    function d_dots_f() {
      if (d_dots_counter === 0) {
        d_dots = '.';
      } else if (d_dots_counter === 1) {
        d_dots = '..';
      } else {
        d_dots_counter = -1;
        d_dots = '';
        if (count_expressions > 4) {
          const t = Math.floor((Math.random() * 10) + 1);
          if (t % 5 === 1) {
            done_gz = done_gz2;
          } else if (t % 5 === 2) {
            done_gz = done_gz3;
          } else if (t % 5 === 3) {
            done_gz = done_gz4;
          } else if (t % 5 === 4) {
            done_gz = done_gz5;
          } else {
            done_gz = done_gz1;
          }
          count_expressions = 0;
        }
      }
      count_expressions++;
      d_dots_counter++;
    }
    const myInterval = setInterval(() => { d_dots_f(); }, 1000);

    // Clear any canvas left over from a previous run AND clear the plugin's
    // stored instance data. Otherwise:
    //   - Without canvas removal: circle-progress appends a new canvas
    //     each call, stacking gauges (visibly doubled segments).
    //   - With canvas removal alone: plugin's $.data still references the
    //     removed canvas, so the next .circleProgress() call no-ops
    //     instead of starting a fresh animation.
    $('#circle1, #circle2').each(function() {
      const $el = $(this);
      $el.removeData('circle-progress');
      $el.find('canvas').remove();
    });

    // Style the canvas BEFORE circle-progress draws into it on the line
    // below: applyCss() runs earlier in this click handler, when no
    // canvas exists yet, so its .find('canvas').css(...) is a no-op for
    // a freshly-rendered gauge. Re-apply the canvas styles here so the
    // baseline descender gap doesn't push the left gauge visually down
    // and the leftward nudge actually lands on the new canvas.
    // display: block kills the inline canvas's baseline descender gap
    // (an inline canvas leaves font-metric whitespace below it that
    // visually drops the row by a few pixels). margin auto centers it
    // horizontally within the .theCanvas div. No left/top offsets —
    // those would shift the radial drawing away from the PNG gauge
    // segments and cause a visible misalignment.
    const canvasCss = {
      display: 'block',
      'text-align': 'center',
      'margin-left': 'auto',
      'margin-right': 'auto',
    };

    $('#circle1').circleProgress({
      value: 0.5,
      thickness: width / 2,
      insertMode: 'append',
      size: width,
      animation: {
        duration: pb_sp * duration_by,
      },
      emptyFill: 'rgba(100,0,0,0.0)',
      fill: {
        image: image3,
      },
    }).on('circle-animation-progress', (event, progress) => {
      if (progress === 1) {
        $(strong1).html(done_gz + d_dots);
        go2 = false;
        if (go3 === false) {
          go1 = false;
          clearInterval(myInterval);
        }
      } else {
        $(strong1).html(in_progress + d_dots);
      }
    });

    $('#circle2').circleProgress({
      value: 0.5,
      thickness: width / 2,
      insertMode: 'append',
      size: width2,
      animation: {
        duration: ot_sp * duration_by, // we are looking for a load of 50% of the image to mark 100% so we multiple by 4
      },
      emptyFill: 'rgba(0,100,0,0.0)',
      fill: {
        image: image3,
      },
    }).on('circle-animation-progress', (event, progress) => {
      if (progress === 1) {
        go3 = false;
        if (go2 === false) {
          go1 = false;
          $(strong1).html('Done!, no more waiting...');
          $(strong2).html('Done! sorry for the wait...');
          clearInterval(myInterval);
        }
      } else {
        $(strong2).html(in_progress + d_dots);
        if (!go2) {
          $(strong1).html(done_gz + d_dots);
        }
      }
    });

    $('#text1').html(message1);
    $('#text2').html(message2);

    // Apply canvas styles AFTER circleProgress has created both canvases.
    // applyCss() ran earlier in this handler when the canvases didn't
    // exist yet, so any canvas-targeted CSS in that path is a no-op for
    // freshly-rendered gauges. The display:block kills the inline
    // baseline descender (which was nudging the gauge visually downward)
    // and the leftward nudge aligns the radial drawing with the gauge
    // segments in the PNG.
    $('#circle1, #circle2').find('canvas').css(canvasCss);
  });
  applyCss();
};
export default speedTest;
